/**
 * --------------------------------------------------------------------------
 * NJ : SearchInput.js
 * --------------------------------------------------------------------------
 */

import { Data, EventHandler } from 'nj-utils';
import AbstractComponent from 'nj-components/AbstractComponent';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

// Required const for all components :
const NAME = 'search-input';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;
const SELECTOR = `.${coreConfig.KEY_PREFIX}-form-input-search`;
const INPUT_CLASS = `${coreConfig.KEY_PREFIX}-form-control`;
const RESET_CLASS = `${coreConfig.KEY_PREFIX}-form-control__reset`;
const DEFAULT_CONFIG = {
  selector : SELECTOR
};

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class SearchInput extends AbstractComponent {
  constructor(element, config) {
    super(SearchInput, element);

    this.element = element;
    this.config = {
      ...DEFAULT_CONFIG,
      ...config
    };

    this.setListeners();
    Data.setData(element, DATA_KEY, this);
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  setListeners() {
    const input = this.element.getElementsByClassName(INPUT_CLASS)[0];
    const resetButton = this.element.getElementsByClassName(RESET_CLASS)[0];
    EventHandler.on(resetButton,
      'click',
      () => {
        input.value = null;
        this.element.classList.remove('is-filled');
      }
    );
  }

  // Static
  static selector = SELECTOR;
}

export default SearchInput;
